export const ERROR_BOUNDARY_LABELS = {
  title: 'Something went wrong',
  subtitle: 'An unexpected error occurred. Please try again.',
  tryAgainButton: 'Try again',
  sessionId: (sessionId: string) => `Session ID: ${sessionId}`,
} as const
